import React from 'react'
import "./Certificate.css";


import charterCertificate from "../images/cert_charter.jpg";
import ferryCertificate from "../images/cert_ferry.jpg";




const Certificate = (props) => {

    let image = false;
    
    switch(props.cert) {
        case "ferry":
            image = ferryCertificate;
            break;
        case "charter":
            image = charterCertificate;
            break;
        default:
            return null;
    }
    
    return (
        <div className="certificate">
            <img className="certificate-image" src={image} alt="{Certificate: props.cert}" />
        </div>
    )
};
export default Certificate;
